import { Alert, Loader, Stack, Table, Text, Title } from '@mantine/core'
import { useTrilha } from '@/hooks/useWhatsappGateways'
import { mensagemDeErro } from './mensagens'

// Lista fechada da spec §6.
const ROTULO_ACAO: Record<string, string> = {
  created: 'Criado', updated: 'Renomeado', deleted: 'Exclusão pedida',
  provision_started: 'Provisionamento iniciado', provisioned: 'Provisionado', provision_failed: 'Provisionamento falhou',
  deprovision_started: 'Remoção iniciada', deprovisioned: 'Removido', deprovision_failed: 'Remoção falhou',
  pairing_started: 'QR gerado', paired: 'Pareado', pairing_expired: 'QR expirou', unlinked: 'Despareado',
  key_assigned: 'Chave apontada', key_unassigned: 'Chave desapontada', restarted: 'Reiniciado',
  update_requested: 'Atualização pedida', update_started: 'Atualização iniciada', version_updated: 'Versão atualizada',
  update_failed: 'Atualização falhou', provision_retried: 'Provisionamento retomado',
  sync_divergence: 'Divergência com o WhatsApi corrigida',
  // ciclo de vida da chave (spec 2026-10-16-whatsapi-chaves-no-ecs)
  key_created: 'Chave criada', key_rotated: 'Chave rotacionada', key_activated: 'Chave ativada',
  key_deactivated: 'Chave desativada', key_deleted: 'Chave excluída',
  // conversas (precursora #26135 e WhatsApi › Conversas, #26143); a primeira fica pelo histórico
  bot_conversa_liberada: 'Conversa devolvida ao bot',
  conversa_assumida: 'Conversa assumida', conversa_respondida: 'Conversa respondida',
  conversa_devolvida: 'Conversa devolvida ao bot',
}

export function rotuloDaAcao(action: string): string {
  return ROTULO_ACAO[action.replace(/^whatsapp_gateway\./, '')] ?? action
}

// Mesmo LIMIT do backend (`trilha.ler`, `limite: int = 100`): quando a resposta vem
// cheia, não dá para distinguir "são exatamente 100 eventos" de "há mais, cortados" —
// o aviso assume o pior caso e diz que a lista não é o histórico inteiro.
const LIMITE_TRILHA = 100

export function TrilhaDoGateway({ orgId, gwId }: { orgId: number; gwId: string }) {
  const t = useTrilha(orgId, gwId)
  const linhas = t.data ?? []
  return (
    <Stack gap="xs">
      <Title order={4}>Trilha</Title>
      {t.isLoading ? (
        <Loader size="sm" />
      ) : t.isError ? (
        <Alert color="red" variant="light">{mensagemDeErro(t.error)}</Alert>
      ) : linhas.length === 0 ? (
        <Text size="sm" c="dimmed">Sem registros.</Text>
      ) : (
        <Stack gap="xs">
          {linhas.length >= LIMITE_TRILHA && (
            <Text size="xs" c="dimmed">mostrando as 100 mais recentes</Text>
          )}
          <Table>
            <Table.Thead>
              <Table.Tr><Table.Th>Quando</Table.Th><Table.Th>O quê</Table.Th><Table.Th>Quem</Table.Th></Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {linhas.map((l, i) => (
                <Table.Tr key={`${l.created_at}-${i}`}>
                  <Table.Td><Text ff="monospace" size="xs">{new Date(l.created_at).toLocaleString('pt-BR')}</Text></Table.Td>
                  <Table.Td>{rotuloDaAcao(l.action)}</Table.Td>
                  <Table.Td><Text size="sm">{l.ator}</Text></Table.Td>
                </Table.Tr>
              ))}
            </Table.Tbody>
          </Table>
        </Stack>
      )}
    </Stack>
  )
}
